export const FETCH_SERVICE_COMMENTS_REQUEST = "FETCH_SERVICE_COMMENTS_REQUEST";
export const FETCH_SERVICE_COMMENTS_SUCCESS = "FETCH_SERVICE_COMMENTS_SUCCESS";
export const FETCH_SERVICE_COMMENTS_FAILED = "FETCH_SERVICE_COMMENTS_FAILED";
export const DELETE_SERVICE_COMMENT_REQUEST = "DELETE_SERVICE_COMMENT_REQUEST";
export const DELETE_SERVICE_COMMENT_SUCCESS = "DELETE_SERVICE_COMMENT_SUCCESS";
export const DELETE_SERVICE_COMMENT_FAILED = "DELETE_SERVICE_COMMENT_FAILED";
export const CREATE_SERVICE_COMMENT_REQUEST = "CREATE_SERVICE_COMMENT_REQUEST";
export const CREATE_SERVICE_COMMENT_SUCCESS = "CREATE_SERVICE_COMMENT_SUCCESS";
export const CREATE_SERVICE_COMMENT_FAILED = "CREATE_SERVICE_COMMENT_FAILED";
